import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import DropDownComponent, { DropDownElement } from '../DropDownComponent'

import { GalleryFilter } from './MediaGalleryComponent'

interface IProps {
  mediaData?: any
  handleFilter: (data: GalleryFilter) => void
}

const TagFilterComponent: React.FC<IProps> = (props) => {
  const [tagOptions, setTagOptions] = useState<DropDownElement[] | null>(null)

  const { t } = useTranslation()

  //  create array of unique tag options
  const createTagOptions = (data: any) => {
    if (data) {
      const tagsArray: any = []

      data.map((item: any) => {
        if (item.tags.length > 0) {
          return item.tags.map((tag: any) => {
            tagsArray.push({ key: tag.id, value: tag.label.toLowerCase() })
          })
        }
      })

      const tagsUnique = tagsArray.filter((value: any, index: number, self: any) => index === self.findIndex((t: any) => (t.key === value.key)))
      setTagOptions(tagsUnique)
    }
  }

  useEffect(() => {
    createTagOptions(props.mediaData)
  }, [props.mediaData])

  return (
    <>
      {tagOptions && (
        <Box>
          <DropDownComponent
            multiple
            options={tagOptions}
            label={t('postingCommon:filterByTags')}
            onChange={(options) => {
              if (Array.isArray(options)) {
                props.handleFilter({ tags: options })
              }
            }}
          />
        </Box>
      )}

    </>
  )
}

export default TagFilterComponent
